import React from 'react';
import PlatopulseAnalytics from 'platopulse/lib/analytics';
import { t } from 'c-3po';

const EmbeddingLegalese = ({ onChange }) =>
    <div className="bordered rounded text-measure p4">
        <h3 className="text-brand">{t`Using embedding`}</h3>
        <p className="text-grey-4" style={{ lineHeight: 1.48 }}>
            {t`By enabling embedding you're agreeing to the embedding license located at`} <a className="link"  href="http://platomedical.com/license/embedding" target="_blank">platomedical.com/license/embedding</a>.
        </p>
        <p className="text-grey-4" style={{ lineHeight: 1.48 }}>
            {t`In plain english, when you embed charts or dashboards from Plato Pulse in your own application, that application isn't subject to the Affero General Public License that covers the rest of Plato Pulse, provided you keep the Plato Pulse logo and the "Powered by Platopulse" visible on those embeds. You should however, read the license text linked above as that is the actual license that you will be agreeing to by enabling this feature.`}
        </p>
        <div className="flex layout-centered mt4">
            <button
                className="Button Button--primary"
                onClick={() => {
                    PlatopulseAnalytics.trackEvent("Admin Embed Settings", "Embedding Enable Click");
                    onChange(true);
                }}
            >
                {t`Enable`}
            </button>
        </div>
    </div>

export default EmbeddingLegalese;



// WEBPACK FOOTER //
// ./admin/settings/components/widgets/EmbeddingLegalese.jsx